"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const OnlineCheckinFlow_1 = require("./OnlineCheckinFlow");
const Wrapper = styled_components_1.default.div `
  color: #666;

  h3,
  h4 {
    color: #212121;
  }

  .break-word {
    word-break: break-word;
  }

  .MuiAlert-root {
    background-color: #fafafa;
  }

  .MuiAlert-icon {
    align-items: center;
    color: #000;
  }
`;
const Balance = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fafafa;
  width: 100%;
  padding: 16px;
  border-radius: 4px;
  flex-wrap: wrap;
`;
const BalanceDetailsBtn = styled_components_1.default.div `
  background-color: #fafafa;
  width: 100%;
  color: ${(props) => `${props.theme.palette.mainAppColor.main}`};
  border-top: 1px solid #eae9ea;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  padding-top: 16px;

  &:hover {
    cursor: pointer;
  }
`;
const PaymentOptions = styled_components_1.default.div `
  background-color: #fafafa;
  width: 100%;
  padding: 16px;
  border-radius: 4px;

  .MuiFormControlLabel-label {
    word-break: break-word;
    width: 100%;
  }
`;
const ButtonWrapper = styled_components_1.default.div `
  width: 100%;
  padding: 16px 0;
`;
const AccountBalance = ({ setDisplayStep, setCreditCardData, setDialogData, setBalanceData, setHeaderText, openErrorDialog, openSpecificErrorDialog, openDialog, closeDialog, setStatusData, match, currentLocale, fromCheckoutFlow, balanceData, userData, kioskModeEnabled, posTerminalEnabled, stayId, }) => {
    const [option, setOption] = (0, react_1.useState)("now");
    const interval = (0, react_1.useRef)(null);
    const autoCheckoutInterval = (0, react_1.useRef)(null);
    const initializeCheckout = () => __awaiter(void 0, void 0, void 0, function* () {
        openDialog();
        let intervalTimer = 1000;
        const token = kioskModeEnabled
            ? localStorage.getItem("kioskUserToken")
            : userData.token;
        yield apiService_1.default
            .initializeCheckout(currentLocale, token, stayId, kioskModeEnabled)
            .then((data) => {
            if (data.status === "success") {
                closeDialog();
                if (data.screen === "status") {
                    setStatusData(data);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                }
                else {
                    setBalanceData(data);
                }
            }
            else if (data.status === "retry") {
                setDialogData({
                    text: data.texts.text,
                    actionText: data.texts.cancelButton,
                    showProgress: true,
                });
                if (data.interval) {
                    intervalTimer = data.interval;
                }
            }
            else if (data.status === "error") {
                openSpecificErrorDialog(data.message);
            }
        })
            .catch(() => {
            openErrorDialog();
        });
        interval.current = setInterval(() => {
            apiService_1.default
                .initializeCheckout(currentLocale, token, stayId, kioskModeEnabled)
                .then((data) => {
                if (data.status === "success") {
                    clearInterval(interval.current);
                    closeDialog();
                    if (data.screen === "status") {
                        setStatusData(data);
                        setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                    }
                    else {
                        setBalanceData(data);
                    }
                }
                else if (data.status === "error") {
                    clearInterval(interval.current);
                    openSpecificErrorDialog(data.message);
                }
            })
                .catch(() => {
                clearInterval(interval.current);
                openErrorDialog();
            });
        }, intervalTimer);
    });
    const initializeAutoCheckout = () => {
        openDialog();
        const intervalTimer = 1000;
        autoCheckoutInterval.current = setInterval(() => {
            apiService_1.default
                .autoCheckout(currentLocale, userData.token)
                .then((data) => {
                if (data.screen === "status") {
                    clearInterval(autoCheckoutInterval.current);
                    setStatusData(data);
                    setHeaderText(data.texts.title);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                    closeDialog();
                }
                else if (data.status === "retry") {
                    setDialogData({
                        text: data.texts.text,
                        actionText: data.texts.cancelButton,
                        showProgress: true,
                    });
                }
                else if (data.status === "error") {
                    clearInterval(autoCheckoutInterval.current);
                    openSpecificErrorDialog(data.message);
                }
            })
                .catch(() => {
                clearInterval(autoCheckoutInterval.current);
                openErrorDialog();
            });
        }, intervalTimer);
    };
    (0, react_1.useEffect)(() => {
        const isAutoCheckout = match.path.includes("guest_journey_auto_checkout");
        if (fromCheckoutFlow && !balanceData && !isAutoCheckout) {
            initializeCheckout();
        }
        if (fromCheckoutFlow && isAutoCheckout) {
            initializeAutoCheckout();
        }
        return () => {
            if (fromCheckoutFlow) {
                clearInterval(interval.current);
                clearInterval(autoCheckoutInterval.current);
            }
        };
    }, []);
    if (!balanceData) {
        return null;
    }
    const handleChange = (event) => {
        setOption(event.target.value);
    };
    const handleSubmit = () => {
        if (!fromCheckoutFlow) {
            const token = kioskModeEnabled
                ? localStorage.getItem("kioskUserToken")
                : userData.token;
            apiService_1.default
                .startAdyenSession(currentLocale, token, option, stayId, kioskModeEnabled, posTerminalEnabled ? "pos_terminal" : "web")
                .then((data) => {
                if (data.status === "error") {
                    openSpecificErrorDialog(data.message);
                    return;
                }
                if (option === "now" && posTerminalEnabled) {
                    setStatusData(data);
                    setDisplayStep(OnlineCheckinFlow_1.POS_TERMINAL_SCREEN);
                }
                else if (option === "now") {
                    setCreditCardData(data);
                    setDisplayStep(OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN);
                }
                else {
                    setStatusData(data);
                    setHeaderText(data.texts.title);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                }
            })
                .catch(() => {
                openErrorDialog();
            });
        }
        else {
            const token = kioskModeEnabled
                ? localStorage.getItem("kioskUserToken")
                : userData.token;
            apiService_1.default
                .startAdyenCheckout(currentLocale, token, option, stayId, kioskModeEnabled)
                .then((data) => {
                if (data.status === "error") {
                    openSpecificErrorDialog(data.message);
                    return;
                }
                if (option === "now") {
                    setCreditCardData(data);
                    setDisplayStep(OnlineCheckinFlow_1.INVOICE_SCREEN);
                }
                else {
                    setStatusData(data);
                    setHeaderText(data.texts.title);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                }
            })
                .catch(() => {
                openErrorDialog();
            });
        }
    };
    const { texts, fields, total } = balanceData;
    const { balanceLabel, headline, hint, submitButton, text } = texts;
    const radioFields = fields ? fields[0] : {};
    const firstLabel = fields ? (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("strong", null, radioFields.options[0].label),
        react_1.default.createElement("p", null, radioFields.options[0].hint))) : null;
    const secondLabel = fields ? (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("strong", null, radioFields.options[1].label),
        react_1.default.createElement("p", null, radioFields.options[1].hint))) : null;
    return (react_1.default.createElement(Wrapper, null,
        hint && react_1.default.createElement(Alert_1.default, { severity: "info" }, hint),
        react_1.default.createElement("h3", null, ifPresent(headline)),
        react_1.default.createElement("p", null, ifPresent(text)),
        react_1.default.createElement(Balance, null,
            react_1.default.createElement("span", null, ifPresent(balanceLabel)),
            react_1.default.createElement("span", null, ifPresent(total)),
            fromCheckoutFlow && (react_1.default.createElement(BalanceDetailsBtn, { onClick: () => {
                    setDisplayStep(OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN);
                } }, balanceData.texts.detailsButton))),
        react_1.default.createElement("h4", { className: "break-word" }, ifPresent(radioFields.label)),
        fields ? (react_1.default.createElement(PaymentOptions, null,
            react_1.default.createElement(RadioGroup_1.default, { defaultValue: radioFields.options[0].selected ? "now" : "later" },
                react_1.default.createElement(FormControlLabel_1.default, { value: "now", control: react_1.default.createElement(Radio_1.default, { onChange: handleChange }), label: firstLabel, labelPlacement: "start" }),
                react_1.default.createElement(FormControlLabel_1.default, { value: "later", control: react_1.default.createElement(Radio_1.default, { onChange: handleChange }), label: secondLabel, labelPlacement: "start" })))) : null,
        react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(Button_1.default, { variant: "contained", size: "large", fullWidth: true, onClick: handleSubmit }, ifPresent(submitButton)))));
};
function ifPresent(value) {
    return value || "";
}
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
    kioskModeEnabled: store.getValue("kioskModeEnabled"),
    posTerminalEnabled: store.getValue('posTerminalEnabled'),
    stayId: store.getValue("stayId"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(AccountBalance));
